export default __webpack_public_path__ + "static/ecom_1-6807272546ff79565b82c3c0e8598bf7.jpeg";